module.exports = __webpack_public_path__ + "static/media/capacitaciones.d54a7b2e.jpg";